/**
 * カート内が「ノベルティ対象」タグの商品のみの場合、チェックアウトボタンを無効化し
 * ボタン上部にアラートを表示する。「ノベルティ」タグの商品が同時に入っていれば制限しない。
 *
 * 判定自体は main-cart-footer.liquid（Liquid 側）で行い、結果を
 * #CartNoveltyState[data-novelty-block] に出力している。
 * カートは非同期更新され、cart.js は #main-cart-footer .js-contents だけを差し替えるため、
 * その差し替えを MutationObserver で検知してボタン／アラートへ反映する。
 */
(function () {
  const FOOTER_ID = 'main-cart-footer';
  const STATE_ID = 'CartNoveltyState';
  const ALERT_ID = 'CartNoveltyAlert';

  function sync() {
    const footer = document.getElementById(FOOTER_ID);
    if (!footer) return;

    const button = footer.querySelector('#checkout');
    if (!button) return;

    const state = footer.querySelector('#' + STATE_ID);
    const alertBox = footer.querySelector('#' + ALERT_ID);

    // 状態要素が無い＝カートが空になった場合。ノベルティ由来の制限は解除する。
    const blocked = !!state && state.dataset.noveltyBlock === 'true';

    if (alertBox) alertBox.hidden = !blocked;

    if (blocked) {
      button.dataset.noveltyBlocked = 'true';
      button.setAttribute('disabled', 'disabled');
      button.setAttribute('aria-disabled', 'true');
    } else if (button.dataset.noveltyBlocked === 'true') {
      delete button.dataset.noveltyBlocked;
      // 食品混在・カート空など他の理由で無効化されている場合は解除しない
      if (button.dataset.checkoutBlockedOther !== 'true') {
        button.removeAttribute('disabled');
        button.removeAttribute('aria-disabled');
      }
    }
  }

  // disabled 属性を外部スクリプトに外された場合や、キーボード操作での送信も防ぐ
  function guardSubmit(event) {
    const button = event.target.closest && event.target.closest('#checkout');
    if (!button) return;
    if (button.dataset.noveltyBlocked === 'true') {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  function init() {
    const footer = document.getElementById(FOOTER_ID);
    if (!footer) return;

    sync();

    // cart.js は #main-cart-footer .js-contents の innerHTML を差し替える。
    // attributeFilter を絞っているため、sync() 自身の disabled/hidden 変更ではループしない。
    const observer = new MutationObserver(sync);
    observer.observe(footer, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-novelty-block'],
    });

    footer.addEventListener('click', guardSubmit, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
